// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"1fc7e143e8af9532","src_app_campaigns_campaign_module_ts":"ed8fbe085f06ce08","src_app_reports_reports_module_ts":"e6860f764e3b7381","src_app_settings_settings_module_ts":"6f8b00c30ca73921","i18n-base":"d1e6a4f46aa96ca3"}[chunkId] + ".js";
};